import React from 'react';

import usePDPUpSellCart from 'data-hooks/usePDPUpSellCart';
import usePDPAddUpSellProductEvent from 'data-hooks/useEvents/usePDPAddUpSellProductEvent';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useCart from 'data-hooks/useCart';
import PDPUpSellProductUI from './PDPUpSellProductUI';
import usePDPOptions from '../state/context/usePDPOptions';

const PDPUpSellProductInner = () => {
  const {
    data: { addingToCart },
    actions: { addToCart, getCart },
  } = useCart();

  const {
    data: {
      hideUpSell,
      optionPrice,
      priceDetails,
      upSellImgFallbackUrl,
      upSellImgUrl,
      upSellProduct,
      upSellProductLink,
    },
  } = usePDPUpSellCart();

  const { data: optionData } = usePDPOptions();

  const addUpSellProductEvent = usePDPAddUpSellProductEvent();

  if (hideUpSell) {
    return null;
  }

  return (
    <PDPUpSellProductUI
      addingToCart={addingToCart}
      addToCart={addToCart}
      addUpSellProductEvent={addUpSellProductEvent}
      getCart={getCart}
      optionPrice={optionPrice}
      parentProductSelectedOptions={optionData.selectedOptions}
      priceDetails={priceDetails}
      upSellImgFallbackUrl={upSellImgFallbackUrl}
      upSellImgUrl={upSellImgUrl}
      upSellProduct={upSellProduct}
      upSellProductLink={upSellProductLink}
    />
  );
};

const PDPUpSellProduct = () => (
  <SuspenseWithLoader>
    <PDPUpSellProductInner />
  </SuspenseWithLoader>
);

export default PDPUpSellProduct;
